
import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import App from "../components/appStartkit";
import { Link } from "gatsby";

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
    <Breadcrumb category={["nyheter", "nyheter"]}  page={["Muntorrhet", "muntorrhet"]}/>
     <SEO title="Muntorrhet" description="Hjälp mot muntorrhet" keywords={[`Muntorrhet`, `andedräkt`, `vita tänder`, `må bättre`, `2022`]}/>
       <h1 class="welcome">Muntorrhet</h1>
     <main>
           <section className="section-metoder">
       <p class="text-center">
      Muntorrhet beror på att du har för lite saliv i munnen eller att salivens sammansättning förändrats. Saliv behövs för att du ska kunna tugga och svälja utan problem. Saliven skyddar också tänderna, till exempel från att få hål. 
    Muntorrhet kan vara svårt att upptäcka själv. Besvären kan komma gradvis och man hinner vänja sig vid att munnen är torrare. Det beror på att den trögflytande delen av saliven som smörjer munnen inte har minskat.
</p>
</section>
              <section className="section-cards">
      <div className="card__ai">
        <h2 class="card-rubrik">Startkit</h2>
        <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
        <App />
        </div>
      </section>

  <section className="section-metoder">
        <h2 class="welcome text-center">Vilka sjukdomar ger muntorrhet?</h2>
        <p class="text-center">Det är viktigt att försöka behandla muntorrhet i tid, annars kan tandköttsinflammation lätt uppstå, eller att risken för karies i tänderna. I värsta fall kan tandköttsinflammation leda till tandlossningssjukdomar. Har man brist på saliv så försämras automatiskt tändernas möjlighet till rengöring, och på så vis uppstår karies lättare eftersom bakterierna trivs bättre. 
        </p> 
        <h2 class="welcome text-center">Varför är jag så torr i munnen?</h2>
        <p class="text-center">Allt som oftast beror muntorrhet på brist på saliv. Det kan också vara så att konsistensen på saliven har ändrats. Muntorrhet är vanligare hos äldre människor. Olika mediciner kan också göra så att muntorrhet lättare uppstår.  
        </p> 
        </section>
<section className="section-cards card-height">
  <div>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </div>
  </section>


        <section className="section-metoder">
        <h2 class="welcome text-center">Hur blir man av med muntorrhet?</h2>
        <p class="text-center">Det är inte roligt att drabbas av muntorrhet, inte bara ökar det risken för sjukdomar. Det kan också förändra smak, orsaka sämre sömnbrist eller obehagskänslor. 
Det finns receptbelagda hjälpmedel som man kan få. Tala gärna med din tandläkare. Välj gärna tuggummi, eller <Link to={"../tandkram"}>tandkräm</Link> med fluorid, eller tabletter som stimulerar salivproduktionen och hjälper till att förbättra din muntorrhet.  
        </p> 
        <h2 class="welcome text-center">Andra bra tips på muntorrhet</h2>
        <p class="text-center"><b>Undvik tobak</b></p>
<p class="text-center">Lättare sagt än gjort, men kanske också en bra anledning till att sluta. Rökning och snusning torkar ut munnen och man bör undvika detta vid muntorrhet.   
        </p> 
        <p class="text-center"><b>Tugga lite extra</b></p>
<p class="text-center">Det är bra att tugga för att öka saliven så därför kan det vara bra att tugga noga när man äter.    
        </p> 
        </section>
   </main> 


  </Layout2>
)

export default IndexPage
